import { cisOdataInstance } from './cis-instance';
import { DynamicDocumentItemResponse } from '@/types/dynamicDoc';

/** ЦИС документы */
export const document = {
    getDynamicDocuments: (id: string): Promise<DynamicDocumentItemResponse[]> =>
        cisOdataInstance.get<DynamicDocumentItemResponse[]>(`RegisterIteration(${id})/GetDynamicDocuments`).then(x => x.data),
};
